module.exports = __webpack_public_path__ + "static/media/tetrapackWrong.42a2af76.png";